import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  IconButton,
  Avatar,
  Grid,
} from "@mui/material";
import {
  Close,
  Notifications,
  CheckCircle,
  Error,
  Person,
  Smartphone,
} from "@mui/icons-material";

const ViewUsersModal = ({ open, onClose, notification }) => {
  if (!notification) return null;

  const {
    title,
    message,
    is_allow_custom_template,
    created_by,
    total_users,
    total_notify_users,
    total_notify_failed_users,
    total_user_list = [],
  } = notification;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xl"
      fullWidth
      PaperProps={{
        sx: {
          maxWidth: "1400px",
          borderRadius: 2,
          background: "#ffffff",
          boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
          minHeight: "600px",
          maxHeight: "90vh",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          py: 2,
          px: 3,
          backgroundColor: "#f8f9fa",
          color: "text.primary",
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Notifications sx={{ mr: 1.5, color: "primary.main" }} />
          <Typography variant="h6" component="div" fontWeight="600">
            Notification Details
          </Typography>
        </Box>
        <IconButton
          onClick={onClose}
          size="small"
          sx={{ color: "text.secondary" }}
        >
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 3 }}>
        <Paper
          elevation={0}
          sx={{
            my: 4,
            borderRadius: 2,
          }}
        >
          <Box>
            <Typography
              variant="body2"
              fontWeight="500"
              gutterBottom
              color="text.secondary"
            >
              Message
            </Typography>
            <Box
              sx={{
                p: 2,
                backgroundColor: "#ffffff",
                borderRadius: 1,
                border: "1px solid #e0e0e0",
              }}
            >
              <Typography variant="body1" color="text.primary">
                {message}
              </Typography>
            </Box>
          </Box>

          <Grid container spacing={3} sx={{ mt: 1 }}>
            <Grid item xs={12} md={6}>
              <Typography
                variant="body2"
                fontWeight="500"
                gutterBottom
                color="text.secondary"
              >
                Is Custom Template?
              </Typography>
              <Box
                sx={{
                  p: 2,
                  backgroundColor: "#ffffff",
                  borderRadius: 1,
                  border: "1px solid #e0e0e0",
                }}
              >
                <Chip
                  label={is_allow_custom_template === 1 ? "Yes" : "No"}
                  color={is_allow_custom_template === 1 ? "success" : "default"}
                  variant={
                    is_allow_custom_template === 1 ? "filled" : "outlined"
                  }
                  size="small"
                  sx={{ fontWeight: 500 }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography
                variant="body2"
                fontWeight="500"
                gutterBottom
                color="text.secondary"
              >
                Created By
              </Typography>
              <Box
                sx={{
                  p: 2,
                  backgroundColor: "#ffffff",
                  borderRadius: 1,
                  border: "1px solid #e0e0e0",
                }}
              >
                <Typography variant="body1" color="text.primary">
                  {created_by || "N/A"}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Paper>

        {/* Statistics */}
        <Grid container spacing={3} sx={{ mb: 4 }}>
          <Grid item xs={12} md={4}>
            <Paper
              elevation={0}
              sx={{
                p: 3,
                borderRadius: 2,
                backgroundColor: "#f8f9fa",
                border: "1px solid #e0e0e0",
                height: "100%",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Avatar
                  sx={{ bgcolor: "primary.main", mr: 2, width: 40, height: 40 }}
                >
                  <Person />
                </Avatar>
                <Box>
                  <Typography variant="body2" color="text.secondary">
                    Total Users
                  </Typography>
                  <Typography
                    variant="h4"
                    fontWeight="700"
                    color="primary.main"
                  >
                    {total_users || 0}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>

          <Grid item xs={12} md={4}>
            <Paper
              elevation={0}
              sx={{
                p: 3,
                borderRadius: 2,
                backgroundColor: "#f8f9fa",
                border: "1px solid #e0e0e0",
                height: "100%",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Avatar
                  sx={{ bgcolor: "success.main", mr: 2, width: 40, height: 40 }}
                >
                  <CheckCircle />
                </Avatar>
                <Box>
                  <Typography variant="body2" color="text.secondary">
                    Total Notified Users:
                  </Typography>
                  <Typography
                    variant="h4"
                    fontWeight="700"
                    color="success.main"
                  >
                    {total_notify_users || 0}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>

          <Grid item xs={12} md={4}>
            <Paper
              elevation={0}
              sx={{
                p: 3,
                borderRadius: 2,
                backgroundColor: "#f8f9fa",
                border: "1px solid #e0e0e0",
                height: "100%",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Avatar
                  sx={{ bgcolor: "error.main", mr: 2, width: 40, height: 40 }}
                >
                  <Error />
                </Avatar>
                <Box>
                  <Typography variant="body2" color="text.secondary">
                    Total Failed Notification Users:
                  </Typography>
                  <Typography variant="h4" fontWeight="700" color="error.main">
                    {total_notify_failed_users || 0}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>
        </Grid>

        {/* Users Table */}
        <Paper
          elevation={0}
          sx={{
            p: 3,
            borderRadius: 2,
            border: "1px solid #e0e0e0",
            backgroundColor: "#fafafa",
          }}
        >
          <Typography
            variant="subtitle1"
            fontWeight="600"
            gutterBottom
            color="text.primary"
            sx={{ display: "flex", alignItems: "center", mb: 3 }}
          >
            <Person sx={{ fontSize: 20, mr: 1 }} />
            User Details
          </Typography>

          {total_user_list.length > 0 ? (
            <TableContainer
              component={Paper}
              elevation={0}
              sx={{
                borderRadius: 1,
                border: "1px solid #e0e0e0",
                maxHeight: "400px",
                overflow: "auto",
              }}
            >
              <Table size="medium" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        backgroundColor: "#f5f5f5",
                        fontWeight: "600",
                        py: 2,
                        fontSize: "0.95rem",
                      }}
                    >
                      User Name
                    </TableCell>
                    <TableCell
                      sx={{
                        backgroundColor: "#f5f5f5",
                        fontWeight: "600",
                        py: 2,
                        fontSize: "0.95rem",
                      }}
                    >
                      Device Name
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        backgroundColor: "#f5f5f5",
                        fontWeight: "600",
                        py: 2,
                        fontSize: "0.95rem",
                      }}
                    >
                      Notified?
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        backgroundColor: "#f5f5f5",
                        fontWeight: "600",
                        py: 2,
                        fontSize: "0.95rem",
                      }}
                    >
                      Notified Date
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        backgroundColor: "#f5f5f5",
                        fontWeight: "600",
                        py: 2,
                        fontSize: "0.95rem",
                      }}
                    >
                      Failed?
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        backgroundColor: "#f5f5f5",
                        fontWeight: "600",
                        py: 2,
                        fontSize: "0.95rem",
                      }}
                    >
                      Notification Read?
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        backgroundColor: "#f5f5f5",
                        fontWeight: "600",
                        py: 2,
                        fontSize: "0.95rem",
                      }}
                    >
                      Notification Read Date
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {total_user_list.map((user, index) => (
                    <TableRow
                      key={`${user.user_id}-${index}`}
                      sx={{
                        "&:nth-of-type(even)": {
                          backgroundColor: "#fafafa",
                        },
                        "&:hover": {
                          backgroundColor: "#f0f4ff",
                        },
                      }}
                    >
                      <TableCell sx={{ py: 2 }}>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Avatar
                            sx={{
                              width: 32,
                              height: 32,
                              mr: 2,
                              bgcolor: "primary.main",
                              fontSize: "14px",
                            }}
                          >
                            {user.user_name
                              ? user.user_name.charAt(0).toUpperCase()
                              : "U"}
                          </Avatar>
                          <Typography variant="body2">
                            {user.user_name || "N/A"}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell sx={{ py: 2 }}>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Smartphone
                            sx={{
                              fontSize: 20,
                              mr: 1,
                              color: "text.secondary",
                            }}
                          />
                          <Typography variant="body2">
                            {user.device_name || "N/A"}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell align="center" sx={{ py: 2 }}>
                        <Chip
                          icon={
                            user.is_notify === 1 ? <CheckCircle /> : <Close />
                          }
                          label={user.is_notify === 1 ? "Yes" : "No"}
                          color={user.is_notify === 1 ? "success" : "default"}
                          size="small"
                          variant={user.is_notify === 1 ? "filled" : "outlined"}
                          sx={{
                            fontWeight: 500,
                            borderRadius: 1,
                          }}
                        />
                      </TableCell>
                      <TableCell align="center" sx={{ py: 2 }}>
                        {user.is_notify === 1 && user.is_failed === 0 ? (
                          <Typography variant="body2">
                            {user.notify_date}
                          </Typography>
                        ) : (
                          <Typography variant="body2" color="text.secondary">
                            -
                          </Typography>
                        )}
                      </TableCell>
                      <TableCell align="center" sx={{ py: 2 }}>
                        {user.is_notify === 0 ? (
                          <Typography variant="body2" color="text.secondary">
                            -
                          </Typography>
                        ) : (
                          <Chip
                            icon={
                              user.is_failed === 1 ? <Error /> : <CheckCircle />
                            }
                            label={user.is_failed === 1 ? "Yes" : "No"}
                            color={user.is_failed === 1 ? "error" : "success"}
                            size="small"
                            variant={
                              user.is_failed === 1 ? "filled" : "outlined"
                            }
                            sx={{
                              fontWeight: 500,
                              borderRadius: 1,
                            }}
                          />
                        )}
                      </TableCell>
                      <TableCell align="center" sx={{ py: 2 }}>
                        {user.is_notify === 1 && user.is_failed === 0 ? (
                          <Chip
                            icon={
                              user.is_notify_read === 1 ? (
                                <CheckCircle />
                              ) : (
                                <Close />
                              )
                            }
                            label={user.is_notify_read === 1 ? "Yes" : "No"}
                            color={
                              user.is_notify_read === 1 ? "success" : "default"
                            }
                            size="small"
                            variant={
                              user.is_notify_read === 1 ? "filled" : "outlined"
                            }
                            sx={{
                              fontWeight: 500,
                              borderRadius: 1,
                            }}
                          />
                        ) : (
                          <Typography variant="body2" color="text.secondary">
                            -
                          </Typography>
                        )}
                      </TableCell>
                      <TableCell align="center" sx={{ py: 2 }}>
                        {user.is_notify_read === 1 ? (
                          <Typography variant="body2">
                            {user.notify_read_date}
                          </Typography>
                        ) : (
                          <Typography variant="body2" color="text.secondary">
                            -
                          </Typography>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Box
              sx={{
                textAlign: "center",
                p: 4,
                backgroundColor: "#ffffff",
                borderRadius: 2,
                border: "1px dashed #e0e0e0",
              }}
            >
              <Notifications
                sx={{ fontSize: 40, color: "text.secondary", mb: 1 }}
              />
              <Typography variant="body2" color="text.secondary">
                No user details available for this notification
              </Typography>
            </Box>
          )}
        </Paper>
      </DialogContent>

      <DialogActions
        sx={{
          p: 3,
          borderTop: "1px solid #e0e0e0",
          backgroundColor: "#f8f9fa",
        }}
      >
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            borderRadius: 1,
            textTransform: "none",
            fontWeight: 500,
            px: 3,
            py: 1,
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewUsersModal;
